<app-input-text-default
  [attribute]="attribute" 
  [envOptions]="envOptions"
  [parent]="parent"
  (onEmit)="emitEvents($event)" >
</app-input-text-default>